/**
 * 確保集裝箱插入 socket（修復 DOMContentLoaded 與 appCore 競態）
 */
const CABINET_SOCKETS = [
    ['consultant', 'consultant-cabinet', 'socket-consultant'],
    ['mapLocate', 'map-locate-cabinet', 'socket-map-locate'],
    ['isochrone', 'isochrone-cabinet', 'socket-isochrone'],
    ['price', 'price-cabinet', 'socket-price'],
    ['bus', 'bus-cabinet', 'socket-bus'],
    ['rail', 'rail-cabinet', 'socket-rail'],
    ['roads', 'roads-cabinet', 'socket-roads'],
    ['poi', 'poi-cabinet', 'socket-poi'],
    ['youbike', 'youbike-cabinet', 'socket-youbike'],
    ['retail', 'retail-cabinet', 'socket-retail'],
    ['parking', 'parking-cabinet', 'socket-parking'],
    ['screenshot', 'screenshot-cabinet', 'socket-screenshot']
];

export function ensureCabinetsDocked(appCore = window.appCore) {
    if (!appCore) return;
    for (const [name, tag, socketId] of CABINET_SOCKETS) {
        const container = document.getElementById(socketId);
        if (!container) continue;
        let instance = appCore.getCabinet(name);
        if (!instance) {
            instance = document.createElement(tag);
            appCore.registerCabinet(name, instance);
        }
        if (!container.contains(instance)) {
            container.innerHTML = '';
            container.appendChild(instance);
        }
    }
}
